import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header pb-0" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Pedidos")
], -1)
const _hoisted_3 = { class: "card-body px-0 pt-0 pb-2" }
const _hoisted_4 = {
  key: 0,
  class: "p-2 align-items-center ms-md-auto"
}
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text text-body" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-search",
    "aria-hidden": "true"
  })
], -1)
const _hoisted_7 = { class: "table-responsive p-0" }
const _hoisted_8 = { class: "table align-items-center mb-0" }
const _hoisted_9 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode()
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", { class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, " Veículo ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", { class: "text-secondary opacity-7" }, null, -1)
const _hoisted_15 = { class: "d-flex px-2 py-1" }
const _hoisted_16 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_17 = { class: "mb-0 text-sm" }
const _hoisted_18 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder" }
const _hoisted_19 = { class: "text-xxs text-secondary mb-0" }
const _hoisted_20 = { class: "text-sm justify-content-center flex-column" }
const _hoisted_21 = {
  key: 0,
  class: "d-flex flex-column badge badge-sm bg-gradient-primary"
}
const _hoisted_22 = {
  key: 1,
  class: "d-flex flex-column badge badge-sm bg-gradient-danger"
}
const _hoisted_23 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "text-sm" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-eye text-secondary",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-map text-secondary",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-trash text-secondary",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_38 = [
  _hoisted_37
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.searchItem)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.searchCall(_ctx.searchIKey,_ctx.searchQuery)), ["enter"])),
                placeholder: "Procurar..."
              }, null, 544), [
                [_vModelText, _ctx.searchQuery]
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("table", _hoisted_8, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_9, [
                _createElementVNode("span", {
                  innerHTML: _ctx.iconSort('numero_pedido')
                }, null, 8, _hoisted_10),
                _hoisted_11,
                _createElementVNode("span", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sortData('numero_pedido')))
                }, " Pedido "),
                _createElementVNode("i", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchData('numero_pedido'))),
                  class: "fas fa-search"
                })
              ]),
              _createElementVNode("th", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sortData('id_operacao'))),
                class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              }, "Endereço"),
              _hoisted_12,
              _hoisted_13,
              _hoisted_14
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedData, (pedido) => {
              return (_openBlock(), _createElementBlock("tr", null, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("h6", _hoisted_17, _toDisplayString(pedido.numero_pedido), 1)
                    ])
                  ])
                ]),
                _createElementVNode("td", _hoisted_18, [
                  _createElementVNode("span", null, _toDisplayString(pedido.endereco1_cliente || "" + " " + pedido.endereco2_cliente || "") + ", " + _toDisplayString(pedido.numero_cliente || "") + " - " + _toDisplayString(pedido.bairro_cliente), 1),
                  _createElementVNode("p", _hoisted_19, _toDisplayString(pedido.cidade_cliente) + "/" + _toDisplayString(pedido.estado_cliente), 1)
                ]),
                _createElementVNode("td", _hoisted_20, [
                  (pedido.id_rota)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, "ALOCADO"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_22, "sem rota"))
                ]),
                _createElementVNode("td", _hoisted_23, [
                  (pedido.rota)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(pedido.rota.veiculo.modelo), 1))
                    : _createCommentVNode("", true),
                  _hoisted_25,
                  (pedido.rota)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(pedido.rota.veiculo.marca), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_27, [
                  _createElementVNode("a", {
                    href: "javascript:;",
                    "data-bs-toggle": "tooltip",
                    onClick: ($event: any) => (_ctx.gotoPedido(pedido)),
                    "data-bs-original-title": "Preview product"
                  }, _hoisted_30, 8, _hoisted_28),
                  _hoisted_31,
                  _createElementVNode("a", {
                    href: "javascript:;",
                    "data-bs-toggle": "tooltip",
                    onClick: ($event: any) => (_ctx.setCenterItem(pedido)),
                    "data-bs-original-title": "Preview product"
                  }, _hoisted_34, 8, _hoisted_32),
                  _hoisted_35,
                  _createElementVNode("a", {
                    href: "javascript:;",
                    "data-bs-toggle": "tooltip",
                    onClick: ($event: any) => (_ctx.removePedido(pedido)),
                    "data-bs-original-title": "Delete product"
                  }, _hoisted_38, 8, _hoisted_36)
                ])
              ]))
            }), 256))
          ])
        ])
      ])
    ])
  ]))
}